module.exports = "{{user}}$${{sid}}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/oauth/oauth.component.html
// module id = ./src/app/admin/oauth/oauth.component.html
// module chunks = main